import type { FunctionComponent } from 'react';

import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { Gap } from '../../../shared/components/gap/gap';
import { Icon } from '../../../shared/components/icon/icon';
import { IconHover } from '../../../shared/components/icon-hover/icon-hover';
import { slugify } from '../../../shared/utils/strings';
import { IActivationStatus } from '../../queries/session-limit-cumulative.graphql';

export interface ILimitStatusHistoryProps {
    activationStatus: IActivationStatus;
    isPendingCancellation: boolean;
}

export const LimitStatusHistory: FunctionComponent<ILimitStatusHistoryProps> = ({
    activationStatus,
    isPendingCancellation,
}) => {
    return (
        <Gap direction="horizontal">
            <FormattedMessage
                id={`limit-history.status.${slugify(activationStatus ? activationStatus : '')}`}
                defaultMessage={`${activationStatus ? activationStatus : ''} {pendingCancellation}`}
                values={{
                    pendingCancellation: isPendingCancellation ? ' - (Pending Cancellation)' : ' ',
                }}
            />
            {(activationStatus === IActivationStatus.Active && isPendingCancellation) ||
            (activationStatus === IActivationStatus.PendingCancellation &&
                !isPendingCancellation) ? (
                <IconHover
                    openToTheLeft
                    hoverItem={<Icon name={'info-circle'} />}
                    infoDisplay={
                        <FormattedMessage
                            id="limit-history.status.label"
                            defaultMessage={
                                activationStatus === IActivationStatus.Active &&
                                isPendingCancellation
                                    ? 'You have cancelled this limit, but it is still in effect due to a cooldown period. This limit will be cancelled automatically when the cooldown period ends unless the cancellation is revoked.'
                                    : activationStatus === IActivationStatus.PendingCancellation &&
                                      !isPendingCancellation
                                    ? 'Your new limit has been applied, but this limit is still active until its configured period ends. Please note that both limits are active during this period.'
                                    : 'No More Information'
                            }
                        />
                    }
                />
            ) : null}
        </Gap>
    );
};
